<template>
  <div
    class="main demo-split"
    id="aa"
    :class="{ mapscreen: $store.state.isMapScreen }"
  >
    <Split v-model="split" min="0" max="400">
      <div slot="left" ref="left" style="height: 100%">
        <monitor-tree
          ref="fleetTree"
          modal="locate"
          deviceUseType="1"
          @videoCmd="playObj"
          @selectCarList="reCarList"
          filterGroup="车辆"
        ></monitor-tree>
      </div>
      <div slot="right" ref="right" style="height: 100%;">
        <!-- <div id="left_right" @click="showHide">
          <Icon v-if="split == 0" type="md-arrow-dropright" />
          <Icon v-else type="md-arrow-dropleft" />
        </div> -->

        <div id="ztmapRight" :style="{ width: 100 - percentWidth + '%' }">
          <div id="locateTools">
            <ButtonGroup vertical>
              <Button
                :type="isSearch ? 'primary' : 'default'"
                icon="ios-search"
                title="搜索位置"
                @click="isSearch = !isSearch"
              ></Button>
              <Button
                :type="isAreaFind ? 'primary' : 'default'"
                icon="md-map"
                title="区域查询"
                @click="areaCar"
              ></Button>
              <Button
                :type="isYun ? 'primary' : 'default'"
                icon="md-cloudy"
                title="卫星云图"
                @click="reYun"
              ></Button>
              <Button
                :type="isLukuang ? 'primary' : 'default'"
                icon="md-car"
                title="路况信息"
                @click="reLuKuang"
              ></Button>

              <Button
                icon="md-pin"
                title="标注点"
                @click="$refs.pointList.open()"
              ></Button>
              <Button
                icon="md-git-merge"
                title="路线规划"
                @click="$refs.lineList.open()"
              ></Button>
              <Button
                icon="ios-disc"
                title="电子围栏"
                @click="$refs.fenceList.open()"
              ></Button>
              <Button
                icon="md-lock"
                title="将正在看的车锁定在地图中心"
                :type="isLock ? 'primary' : 'default'"
                @click="lockCar"
              ></Button>
            </ButtonGroup>
          </div>
          <g-map
            ref="postDevice"
            @dataWindow="dataWindow = $event"
            @areaCar="$refs.quyuchache.areaCarFunction($event)"
          >
            <!-- <icon-window
              ref="infoWindow"
              @video="reVideo"
              @openSpeak="openSpeak"
              @pauseSpeak="pauseSpeak"
              @closeSpeak="closeSpeak"
              :windowData="dataWindow"
              slot="window"
            >
            </icon-window> -->
            <icon-window
              ref="infoWindow"
              @video="reVideo"
              @openVisibleSpeek="openVisibleSpeek"
              :windowData="dataWindow"
              slot="window"
            >
            </icon-window>
          </g-map>
        </div>
        <div
          id="ztmapLeft"
          v-show="openVideo"
          :style="{
            width: percentWidth + '%',
            height: 'calc(100% - ' + (height - 30) + 'px)'
          }"
        >
         <!--  <myVideo
            :pagesnumber="4"
            ref="vueVideo"
            @openVideo="openVideoFun"
            @closeVideo="closeVideo"
          ></myVideo> -->
        </div>
        <div id="locateSearch" v-if="isSearch">
          <search-add @adds="reAdds"></search-add>
        </div>

        <div id="map-bottom" :style="{ height: height + 'px)' }">
          <locateList
            ref="locateList"
            @status="restatus"
            @tr="$refs.postDevice.showWindow($event, true)"
          ></locateList>
        </div>
      </div>
    </Split>
    <quyuchache ref="quyuchache"></quyuchache>
    <point-list @points="showPoints" ref="pointList"></point-list>
    <line-list @lines="showLineFun" ref="lineList"></line-list>
    <fence-list @fences="showFence" ref="fenceList"></fence-list>
    
    
  </div>
</template>
<script>
import monitorTree from "./locateToolCarPerson.vue";

var m = localStorage.getItem("contact");

import gMap from "../map/locate.vue";
import locateList from "./locateList.vue";
import iconWindow from "./iconWindow";

import quyuchache from "./quyuchache.vue";
//import byVideo from "../video/bsjVideo.vue";
//import lyVideo from "../video/video.vue";
//import speekModal from "../common/speekModal.vue";
//import speakWin from "./speakWin.vue";
export default {
  props: ["isToCenter"],
  components: {
    //speakWin,
    locateList,
    monitorTree,
    gMap,
    iconWindow,
    //myVideo: m == "云视频" ? byVideo : lyVideo,
    quyuchache,
    //speekModal
  },
  data() {
    return {
      split: "260",
      isSearch: false,
      isDrawRule: false,
      isYun: false,
      isLukuang: false,
      isAreaFind: false,
      isLock: false,
      leftLoteData: [],
      height: 200,
      dataWindow: {},
      openVideo: false,
      name: "",
      percentWidth: 0,

      visibleSpeek: false,
      IsSpeek: false,
      deviceNo: "",
      carNo: ""
    };
  },

  methods: {

    areaCar() {
      this.isAreaFind = !this.isAreaFind;
      this.$refs.postDevice.areaCar(this.isAreaFind);
    },

    reYun() {
      this.isYun = !this.isYun;
      this.$refs.postDevice.reYun(this.isYun);
    },
    reLuKuang() {
      this.isLukuang = !this.isLukuang;
      this.$refs.postDevice.reLuKuang(this.isLukuang);
    },
    lockCar() {
      this.isLock = !this.isLock;
      this.$refs.postDevice.lockCar(this.isLock);
    },
    reCeju() {
      this.isDrawRule = !this.isDrawRule;
      this.$refs.postDevice.reCeju(this.isDrawRule);
    },
    reAdds(v) {
      this.$refs.postDevice.reAdds(v);
    },
    showPoints(v) {
      this.$refs.postDevice.showPoints(v);
    },
    showLineFun(v) {
      this.$refs.postDevice.showLineFun(v);
    },
    showFence(v) {
      this.$refs.postDevice.showFence(v);
    },

    showHide() {
      if (this.split == 0) {
        this.split = "260";
        this.$refs.left.style.display = "block";
      } else {
        this.split = 0;
        this.$refs.left.style.display = "none";
      }
    },
    setHight() {},
    reCarList(v, isToCenter) {
      // if (this.visibleSpeek) this.closeSpeakModel(this.deviceNo); //切换车辆时，关闭对讲

      this.$refs.postDevice.websockToLocate(v, isToCenter);
      this.$refs.locateList.websockToLocate(v, isToCenter);

      //
    },
    restatus(v) {
      if (v == 0) {
        this.height = 46;
      } else {
        this.height = 200;
      }
    },
    closeVideo() {
      this.openVideo = false;
      this.percentWidth = 0;
    },
    openVideoFun() {
      this.openVideo = true;
      this.percentWidth = 70;
    },
    playObj(obj) {
      this.openVideoFun();

      this.$refs.vueVideo.open(obj);
    },
    //控制子组件播放视频
    reVideo(obj) {
      this.openVideoFun();
      console.log("控制子组件播放视频", obj);
      console.log("obj.deviceNo", obj.deviceNo);

      let playObj = {
        deviceModel: obj.deviceModel,
        deviceNo: obj.deviceNo,
        carNo: obj.carNo,
        deviceProtocol: obj.deviceProtocol,
        videoConfig: obj.videoConfig,
        play: true
      };
      // console.log("播放视频数据", playObj);
      this.$refs.vueVideo.open(playObj);
    },

    // 紧急报警对讲
    openAlarm(obj) {
      this.openVideoFun();
      let playObj = {
        deviceModel: obj.deviceModel,
        carNo:obj.carNo,
        deviceNo: obj.deviceNo,
        deviceProtocol: obj.deviceProtocol,
        videoConfig: obj.videoConfig,
        play: true
      };
      // console.log("播放视频数据", playObj);
      this.$refs.vueVideo.open(playObj);
      this.openVisibleSpeek(playObj);

      this.$refs.speakWinRef.IsShow = false;
    },

    // // 打开弹窗
    openVisibleSpeek(data) {
      this.deviceNo = data.deviceNo;
      this.carNo = data.name;
      this.visibleSpeek = true;
    },
    // 开启对话
    openSpeak(data) {
      if (data.IsSpeek) {
        this.$refs.vueVideo.openSpeak(data.deviceNo);
      } else {
        this.pauseSpeak(data.deviceNo);
      }
    },

    // 暂停对讲
    pauseSpeak(deviceNo) {
      this.$refs.vueVideo.closeSpeak(deviceNo);
    },
    // 关闭对讲
    closeSpeakModel(deviceNo) {

      console.log("closeSpeakModel关闭对讲");

      this.$refs.vueVideo.closeSpeak(deviceNo);
      this.deviceNo = "";
      this.$refs.speekModalRef.IsSpeek = false;
      this.visibleSpeek = false;
    }
  },
  mounted() {
    //this.setHight();
    if (m == "云视频") {
    } else {
      // this.split = Number(localStorage.getItem("Split1"));
    }
  },

  deactivated() {
    //console.log("离开页面了");
  },
  activated() {
    //console.log("回来页面了");
  }

  //vue缓存页面重新进入的钩子函数
};
</script>
<style>
/*去除百度地图版权*/
.anchorBL {
  display: none;
}

.demo-split {
  position: relative;
  border: 1px solid #dcdee2;
}

#left_right {
  position: absolute;
  left: 0;
  top: 48%;
  background: #333;
  width: 18px;
  line-height: 60px;
  z-index: 18;
  color: #fff;
  font-size: 18px;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
  opacity: 0.3;
}

#left_right:hover {
  opacity: 0.5;
}

.mapscreen {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 6666;
  width: 100%;
  height: 100% !important;
  background: #f5f5f5;
  padding-top: 0 !important;
}

#map-top {
  height: 100%;
}

#map-bottom {
  overflow: hidden;
  position: absolute;
  bottom: 0;
  background: rgb(255, 255, 255);
  width: 100%;
  z-index: 222;
}

#locateTools {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 22;
}

#locateSearch {
  position: absolute;
  top: 10px;
  left: 50px;
  z-index: 22;
}

.alarmNow {
  background: #e60909;
  color: #fff;
  padding: 0 4px;
  margin-right: 2px;
}

#video_wrap {
  position: absolute;
  z-index: 24;
  top: 50px;
  right: 6px;
  background: #ccc;
  width: 200px;
}

#ztmapLeft {
  width: 70%;
  /* height: calc(100% - 170px); */
  /* aspect-ratio: 16/9; */
  float: right;
}

#ztmapRight {
  width: 30%;
  height: 100%;
  position: relative;
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/locate/carLocate.vue